import { Injectable, inject } from '@angular/core';
import { Subject, fromEvent } from 'rxjs';
import { Platform } from '@angular/cdk/platform';
import { WINDOW_TOKEN } from './window.token';
import { MediaQueryService } from './media-query.service';
import type { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PlatformService {
  private readonly platform = inject<Platform>(Platform);
  private readonly mediaQueryService = inject<MediaQueryService>(MediaQueryService);
  private readonly browserWindow = inject<Window>(WINDOW_TOKEN);

  static readonly BREAKPOINT: number = 1024;
  private _onScreenSizeChange: Subject<boolean>;
  private screenHeight: number;
  private screenWidth: number;

  constructor() {
    this.screenHeight = this.browserWindow.screen.height;
    this.screenWidth = this.browserWindow.screen.width;
  }

  get onScreenSizeChange(): Observable<boolean> {
    if (this._onScreenSizeChange === undefined) {
      this._onScreenSizeChange = new Subject<boolean>();

      if (this.isIOS()) {
        fromEvent(this.browserWindow, 'orientationchange')
          .subscribe((): void => {
            this.refreshScreenSize();
          });
      } else {
        fromEvent(this.browserWindow, 'resize')
          .subscribe((): void => {
            this.refreshScreenSize();
          });
      }
    }
    return this._onScreenSizeChange;
  }

  // This will return true on Chrome if device emulation is set to iPhone! Useful but tricky!
  isIOS(): boolean {
    return this.platform.WEBKIT &&
      (this.platform.IOS || (this.platform.SAFARI && this.mediaQueryService.isTouchDevice()));
  }

  isMobileOrTabletPortraitView(): boolean {
    return (this.platform.ANDROID && this.screenWidth < PlatformService.BREAKPOINT) ||
     (this.isIOS() && this.getIOSWidth() < PlatformService.BREAKPOINT);
  }

  private refreshScreenSize(): void {
    this.screenWidth = this.browserWindow.screen.width;
    this.screenHeight = this.browserWindow.screen.height;
    this._onScreenSizeChange.next(true);
  }

  private getIOSWidth(): number {
    return this.isPortrait() ? this.screenWidth : this.screenHeight;
  }

  private isPortrait(): boolean {
    const orientation = this.browserWindow['orientation'];
    return orientation === 0 || orientation === 180;
  }
}
